<template>
  <div class="event race">
    <div class="event-header">
      <span class="event-date">{{ race.datetime.date() }}</span>
      <span class="event-name">ZAWODY</span>
      <span class="event-actions">
        <v-icon dark class="click-effect" v-if="isActiveRunnerTrainer || isActiveRunner" v-tooltip="'Edytuj'" @click.stop="$emit('edit-race')">edit</v-icon>
        <v-icon dark class="click-effect" v-if="isActiveRunnerTrainer || isActiveRunner" v-tooltip="'Usuń'" @click.stop="$emit('remove-race')">delete</v-icon>
      </span>
    </div>
    <div class="event-content">
      <ul>
        <li v-if="!measureable"><i v-tooltip="'Dystans'" class="fi flaticon-road-1 mr-1"></i> {{race.race_type_name }}: {{race.distance_km }} km</li>
        <li v-if="measureable"><i v-tooltip="'Dystans'" class="fi flaticon-road-1 mr-1"></i> {{race.race_type_name }}: {{race.distance_string_name }}</li>
        <li><i v-tooltip="'Priorytet'" class="text-icon mr-1">P</i> {{race.priority }}</li>
        <li><i v-tooltip="'Nazwa'" class="text-icon mr-1">N</i> {{race.name }}</li>
      </ul>
    </div>
    <div class="event-footer">
      <span></span>
      <span v-if="race.trainer_remarks" v-tooltip="race.trainer_remarks"><v-icon>info</v-icon></span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    race: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(['isActiveRunnerTrainer', 'isActiveRunner']),
    measureable () {
      return this.race.distance_string !== 'other' && this.race.distance_string !== 'ultra'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plan/RaceSmall.vue